import { render, staticRenderFns } from "./TheoryQuestionsAdd.vue?vue&type=template&id=3250a7da&scoped=true&"
import script from "./TheoryQuestionsAdd.js?vue&type=script&lang=js&"
export * from "./TheoryQuestionsAdd.js?vue&type=script&lang=js&"
import style0 from "./TheoryQuestionsAdd.vue?vue&type=style&index=0&id=3250a7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3250a7da",
  null
  
)

export default component.exports